import { DatePicker, Form, Modal, Select } from 'antd';
import { useEffect, useState } from 'react';
import moment from 'moment';

const { Option } = Select;

interface ScheduleImportModalProps {
  visible: boolean;
  projectData: any[];
  onCreate: (data: any) => void;
  onCancel: () => void;
}

function ScheduleImportModal({
  visible,
  projectData,
  onCreate,
  onCancel,
}: ScheduleImportModalProps) {
  const [form] = Form.useForm();
  const [mount, setMount] = useState(true);
  const [projectList, setProjectList] = useState<any[]>();
  const searchSubScheduleList = async (formData: any) => {};

  useEffect(() => {
    if (!mount) return;
    let children: any = [];
    for (const project of projectData.sort((a: any, b: any) =>
      b.startDate.localeCompare(a.startDate),
    )) {
      children.push(
        <Option key={project.id} value={project.id}>
          {project.name} ({project.startDate} ~ {project.endDate})
        </Option>,
      );
    }
    setProjectList(children);

    return () => setMount(false);
  }, [projectData, mount]);

  return (
    <>
      <Modal
        open={visible}
        title="공정 불러오기"
        okText="확인"
        cancelText="취소"
        width={700}
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              onCreate(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Form
          form={form}
          onFinish={searchSubScheduleList}
          initialValues={{
            baseDate: moment(),
          }}
        >
          <Form.Item
            name={['project', 'id']}
            label="프로젝트"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select style={{ width: '100%' }}>{projectList}</Select>
          </Form.Item>

          <Form.Item
            name="baseDate"
            label="기준일"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );

  /*
  return (
    <>
      <Modal
        open={visible}
        title="공정 생성"
        okText="확인"
        cancelText="취소"
        width={800}
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              console.log(values);
              onCreate(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Form
          form={form}
          onFinish={searchSubScheduleList}
          initialValues={gongjongList}
        >
          <Form.List name="nameList">
            {(fields, { add, remove, move }) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => (
                  <Row justify={'center'}>
                    <Col span={8}>
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'name']}
                          rules={[
                            { required: true, message: '공정명을 입력하세요' },
                          ]}
                          key={key}
                        >
                          <Input
                            placeholder="예) 철거공사"
                            style={{ width: '200px' }}
                          />
                        </Form.Item>
                        <MinusCircleOutlined
                          onClick={() => {
                            remove(name);
                          }}
                          rev={undefined}
                        />
                        <ArrowUpOutlined
                          onClick={() => move(index, index - 1)}
                          disabled={index === 0}
                          rev={undefined}
                        />
                        <ArrowDownOutlined
                          onClick={() => move(index, index + 1)}
                          disabled={index === fields.length - 1}
                          rev={undefined}
                        />
                      </Space>
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Row justify={'center'}>
                    <Col span={8}>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined rev={undefined} />}
                      >
                        추가
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    </>
  );
  */
}

export default ScheduleImportModal;
